import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NgbActiveOffcanvas, NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { ReactiveFormsModule } from '@angular/forms'
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight'
import { NgSelectModule } from '@ng-select/ng-select'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service'
import { Appointment } from 'src/app/shared/interfaces/appointment/appointment.interface'
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps'
import { PostListItem } from 'src/app/shared/interfaces/post/post-list-item.interface'
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service'
import { RouterModule } from '@angular/router'

@Component({
    selector: 'sf-post-pullout',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        NgbModule,
        NgSelectModule,
        GoogleMapsModule,
        ButtonComponent,
        NgOptionHighlightModule,
    ],
    templateUrl: './post-pullout.component.html',
    styleUrls: ['./post-pullout.component.scss'],
})
export class PostPulloutComponent implements OnInit {
    activeOffcanvas: NgbActiveOffcanvas = inject(NgbActiveOffcanvas)
    appointmentService: AppointmentService = inject(AppointmentService)
    confirmationService: ConfirmationDialogService = inject(ConfirmationDialogService)

    @Input() post!: PostListItem

    @Output() closed = new EventEmitter<void>()

    appointment: Appointment | null = null

    @ViewChild(GoogleMap) map!: google.maps.Map
    center: google.maps.LatLngLiteral = { lat: 24, lng: 12 }
    markerOptions: google.maps.MarkerOptions = { draggable: false }
    markerPositions: any[] = [] // google.maps.LatLngLiteral[] = []

    ngOnInit(): void {
        if (this.post.appointmentId) {
            this.appointmentService.getAppointmentById(this.post.appointmentId).subscribe((appointment) => {
                this.appointment = appointment

                // this.map.setCenter({
                //     lat: parseInt(appointment.customer.latitude!),
                //     lng: parseInt(appointment.customer.longitude!),
                // })

                if (appointment.customer.latitude && appointment.customer.longitude) {
                    const lat = parseFloat(appointment.customer.latitude)
                    const lng = parseFloat(appointment.customer.longitude)

                    this.addMapMarker(
                        appointment.appointmentReference,
                        appointment.customer.fullAddress.addressLine1,
                        lat,
                        lng
                    )
                } else {
                    // remove map
                }
            })
        }
    }

    addMapMarker(title: string, address: string, lat: number, lng: number): void {
        // set the map center location
        this.center = {
            lat: lat,
            lng: lng,
        }

        // add marker
        const marker = {
            position: { lat: lat, lng: lng },
            label: { color: 'blue', text: address },
            title: title,
            options: { animation: google.maps.Animation.DROP },
        }
        this.markerPositions.push(marker)
    }

    dismiss(): void {
        this.activeOffcanvas.dismiss()
    }
    close(): void {
        this.activeOffcanvas.close()
    }

    deletePost(): void {
        this.confirmationService
            .confirm('Delete Post', 'Are you sure you want to delete this post?')
            .then((confirmed) => {
                if (confirmed) {
                    alert('handle delete')
                    this.close()
                }
            })
    }

    voidPost(): void {
        this.confirmationService.confirm('Void Post', 'Are you sure you want to void this post?').then((confirmed) => {
            if (confirmed) {
                alert('handle void')
                this.close()
            }
        })
    }
}
